// extracted by mini-css-extract-plugin
export default {"add-btn":"IP8jR5QMej0cl7U8sX57"};